import React, { forwardRef } from 'react';
import { Switch, Modal } from 'zarm';
import { Icon } from '@iyunbao/components';

import UItem from '../item';
import { clearObj } from '../../utils/tools';
import { BaseWidgetProps, OptionsProps } from '../../utils/type';

export interface SwitchProps extends BaseWidgetProps {
  value?: any;
  defaultValue?: any;
  label?: string;
  options: OptionsProps;
  disabled?: boolean;
  readonly?: boolean;
  readOnly?: boolean;
  className?: string;
  tag?: string;
  tips?: string;
  validate?: {
    rules: any[];
  };
}

function getValue(props: SwitchProps) {
  const { value, defaultValue } = props;

  if (typeof value !== 'undefined') {
    return value;
  }

  return defaultValue || false;
}

const SwitchContent = forwardRef((props: SwitchProps, ref: any) => {
  const {
    prefixCls,
    label,
    disabled,
    tag,
    tips,
    children,
    onChange,
  } = props;

  return (
    <>
      <div className={`${prefixCls}-header`}>
        <div className={`${prefixCls}-label`}>
          {label}
        </div>
        {!!tag && <div className={`${prefixCls}-tag`}>{tag}</div>}
        {!!tips && (
          <div className={`${prefixCls}-tips`}>
            <Icon
              type="wenhao"
              onClick={() => Modal.alert({
                content: tips,
              })}
            />
          </div>
        )}
        <div className={`${prefixCls}-more`}>
          <Switch
            ref={ref}
            disabled={disabled}
            checked={getValue(props)}
            onChange={onChange}
          />
        </div>
      </div>
      {children ? <div className={`${prefixCls}-body`}>{children}</div> : null}
    </>
  );
});

// 表单 输入框组件
function SwitchPanel(props: SwitchProps) {
  const {
    prefixCls = 'crm-switch-panel',
    label,
    value,
    defaultValue,
    disabled,
    className,
    options,
    tag,
    tips,
    _crengine,
    children,
    ...rest
  } = props;
  const { form } = _crengine || {};

  // 子项内容改变的时候进行数据更新
  function onValueChange(v: any) {
    const { onChange, ...changeRest } = props;

    if (onChange) {
      onChange({
        ...changeRest,
        value: v,
      });
    }
  }

  const switchProps = clearObj({
    prefixCls,
    className,
    label,
    defaultValue,
    value,
    tag,
    tips,
    options,
    disabled,
    children,
    onChange: onValueChange,
  });

  // 如果wform存在 则去除input组件的某些属性
  if (form) {
    delete switchProps.value;
    delete switchProps.defaultValue;
    delete switchProps.onChange;
  }

  return (
    <UItem
      {...rest}
      itemType="switchPanel"
      prefixCls={prefixCls}
      _crengine={_crengine}
      samePath
      initialValue={getValue(props)}
      validateTrigger="onChange"
      onChange={onValueChange}
    >
      <SwitchContent {...switchProps} />
    </UItem>
  );
}

export default SwitchPanel;
